import { gql } from "apollo-boost";
import blocks from "blocks/query";
import { seomatic } from "querypieces";

export default gql`
  query($uri: String) {
    entry(uri: [$uri]) {
      ...on page_Entry {
        typeHandle
        pageBuilder {
          ${blocks}
        }
      }
    }
    ${seomatic}
  }
`;
